import type {
  IOnboardingGetOrgProfileParams,
  IOnboardingGetOrgProfileRequest,
  IOnboardingGetOrgProfileResponse,
} from '@/app-package';

import axios from 'axios';

const getProfile = async (params: IOnboardingGetOrgProfileParams) => {
  const url = `/onboarding/profile/org/${params.hash}`;

  const config: IOnboardingGetOrgProfileRequest = { url, method: 'get' };

  const { data } =
    await axios.request<IOnboardingGetOrgProfileResponse>(config);

  return data;
};

export default getProfile;
